import { signOut } from 'next-auth/react'

// Ends the app session (the server revokes the refresh token), then sends the
// browser to Cognito /logout. Only /logout clears Cognito's own sign-in cookie;
// without it, the next person on this browser can be signed in as this user
// for up to an hour, with no password (DEV-1719).
export async function signOutOfCognito() {
  const cognitoDomain = process.env.NEXT_PUBLIC_COGNITO_DOMAIN ?? ''
  const clientId = process.env.NEXT_PUBLIC_AUTH_APP_CLIENT_ID ?? ''
  const appUrl = encodeURIComponent(process.env.NEXT_PUBLIC_APP_URL ?? '')
  const cognitoLogoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&scope=openid&response_type=code&logout_uri=${appUrl}&redirect_uri=${appUrl}`

  // NextAuth's redirect callback rejects off-site URLs, so a callbackUrl here
  // would silently drop the Cognito redirect. Clear the session without a
  // redirect, then navigate.
  await signOut({ redirect: false })

  window.location.href = cognitoLogoutUrl
}
